<!--
=========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
-->
<template>
  <div class="parentx">

    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">

        <!-- Header -->
        <div class="header-sidebar flex items-end justify-between" slot="header">

          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/">
            <!--
            <logo class="w-10 mr-4 fill-current text-primary" />
            <span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">
              {{ title }}
            </span>
            -->
            <div v-if="!reduce || isMouseEnter">
              <img
                v-bind:src="logoFull"
                style="max-height:60px; max-width: 190px; object-fit: contain;"
              />
            </div>
            <div v-if="reduce && !isMouseEnter">
              <img v-bind:src="logoMini" style="width:35px"/>
            </div>
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer"
                            @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)"/>
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)"/>
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom"/>

        <!-- Menu Items -->
        <CheckPermission permission="ED075">
          <component
            :is="scrollbarTag"
            ref="verticalNavMenuPs"
            class="scroll-area-v-nav-menu pt-2"
            :settings="settings"
            @ps-scroll-y="psSectionScroll"
            @scroll="psSectionScroll"
            :key="$vs.rtl"
          >
            <template v-for="(item, index) in menuItemsUpdated">

              <!-- Group Header -->
              <span
                v-if="item.header && !verticalNavMenuItemsMin"
                class="navigation-header truncate"
                :key="`header-${index}`"
              >
              {{ item.header }}
            </span>
              <!-- /Group Header -->

              <template v-else-if="!item.header">

                <!-- Nav-Item -->
                <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :permission="item.permiso"
                  :to="item.slug !== 'external' ? item.url : null"
                  :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon" :target="item.target"
                  :isDisabled="item.isDisabled"
                  :slug="item.slug">
                  <span
                    :data-cy-label="item.name"
                    data-cy="sub-menu"
                    v-show="!verticalNavMenuItemsMin"
                    class="truncate"
                  >
                    {{ item.name }}
                  </span>
                  <vs-chip
                    class="ml-auto"
                    :color="item.tagColor"
                    v-if="item.tag && (isMouseEnter || !reduce)"
                  >
                    {{ item.tag }}
                  </vs-chip>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group
                    :key="`group-${index}`"
                    :permission="item.permiso"
                    :openHover="openGroupHover"
                    :group="item"
                    :groupIndex="index"
                    :open="isGroupActive(item)"/>
                </template>
                <!-- /Nav-Group -->
              </template>
            </template>
          </component>
        </CheckPermission>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"/>
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapActions, mapState } from 'vuex';

import Logo from '../Logo';

import VNavMenuGroup from './VerticalNavMenuGroup';
import VNavMenuItem from './VerticalNavMenuItem';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import { MENU_COLLAPSE_GROUPS } from '@/constants/settings';

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
    CheckPermission
  },
  mixins: [PersonalizacionMixin],
  props: {
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String }
  },
  data: () => ({
    product: process.env.VUE_APP_PRODUCTO,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    menuInteracted: false, // flag para permitir colapso inicial de grupos del menú (configurable por parámetro)
    settings: { // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    showShadowBottom: false
  }),
  computed: {
    ...mapState('Personalizacion', {
      logoFull: (state) => state.menu.logo,
      logoMini: (state) => state.menu.miniLogo
    }),
    companyIut() {
      return this.$store.getters['Empresas/company']
        ? this.$store.getters['Empresas/company'].iut
        : null;
    },
    colapsarMenuInicial() {
      const value = this.$store.state.Empresas.settings[MENU_COLLAPSE_GROUPS];
      if (!value) return false;
      if (typeof value === 'string') return value === 'Y';
      return (value.valorEmpresa || value.valorPortal || value.valorGlobal) === 'Y';
    },
    isGroupActive() {
      return (item) => {
        // Si el parámetro io.web.ed.menu.colapsar.grupos está activo,
        // todos los grupos inician colapsados hasta la primera navegación
        if (
          this.colapsarMenuInicial
          && !this.menuInteracted
        ) {
          return false;
        }

        const path = this.$route.fullPath;
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined;
        let open = false;

        const func = (currentItem) => {
          if (currentItem.submenu) {
            currentItem.submenu.forEach((subMenuItem) => {
              if (
                subMenuItem.url
                  && (path === subMenuItem.url || routeParent === subMenuItem.slug)
              ) {
                open = true;
              } else if (subMenuItem.submenu) {
                func(subMenuItem);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      const clone = this.navMenuItems.slice();

      // TODO: refactor this
      this.navMenuItems.forEach((item, index) => {
        if (item.header && item.items.length && (index || 1)) {
          const i = clone.findIndex((ix) => ix.header === item.header);
          item.items.forEach((subItem, subIndex) => {
            clone.splice(i + 1 + subIndex, 0, subItem);
          });
        }
      });

      const dontShowMenus = ['super-board', 'board'];
      if (this.product === 'aprobacionesApp') {
        return clone.filter((menu) => !dontShowMenus.includes(menu.slug));
      }

      const companyIut = this.companyIut;
      return clone.filter((menu) => !menu.hideCompany?.includes(companyIut));
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val);
      }
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val);
      }
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);

      // Después de la primera navegación, permitir que los grupos se abran normalmente
      if (!this.menuInteracted && this.colapsarMenuInicial) {
        this.menuInteracted = true;
      }
    },
    reduce(val) {
      // eslint-disable-next-line no-nested-ternary
      const verticalNavMenuWidth = val ? 'reduced' : this.$store.state.windowWidth < 1200 ? 'no-nav-menu' : 'default';
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    }
  },
  methods: {
    ...mapActions('Empresas', ['fetchCompanySetting']),
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton) {
          this.isVerticalNavMenuActive = false;
        }
      } else if (event.direction === 2 && !this.$vs.rtl) { // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) {
          this.isVerticalNavMenuActive = false;
        }
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton) {
          this.isVerticalNavMenuActive = true;
        }
      } else if (event.direction === 2 && this.$vs.rtl) { // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) {
          this.isVerticalNavMenuActive = true;
        }
      }
    },
    psSectionScroll() {
      const scrollEl = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scrollEl.scrollTop > 0;
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 992) {
        if (this.layoutType === 'vertical') {
          // Set reduce
          this.reduce = !!this.reduceButton;

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!((this.reduceButton && !this.isMouseEnter));
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin);

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? 'reduced' : 'default';
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth);

          return;
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false);

      // if (
      //  this.layoutType === 'vertical'
      //  || (this.layoutType === 'horizontal' && this.windowWidth < 1200)
      // )
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    }
  },
  created() {
    // El parámetro io.web.ed.menu.colapsar.grupos se carga desde caché (vuex-persist)
    // y se refresca en SelectorEmpresa al seleccionar empresa.
    // No es necesario volver a llamar a la API aquí.
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  }
};

</script>

<style lang="scss">
@import "../../../assets/scss/vuexy/components/verticalNavMenu.scss";
</style>
